import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  defaultTitle: {
    description: 'bulkPresetDropdown.defaultTitle',
    defaultMessage: 'Select a Preset',
    id: 'xFi2Xr',
  },
});
